/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import PanelBoxLayout from 'components/layout/panelBox';
import TextInput from 'components/form/textInput';
import FieldPair from 'components/form/fieldPair';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import { Formik } from 'formik';
import { ValidationTicketCategory } from 'common/validations';
import UploadIcon from 'components/form/uploadIcon';
import TreeSelectInput from 'components/form/treeSelect';
import { useActions } from 'common/hooks/useActions';

import * as T from 'common/types';
import * as S from './styles';

interface IProps {
  categories: any[];
  supporterList: any[];
  supporter: any[];
  data?: any;
}

export default function CategorieyDetailForm({ categories, supporterList, supporter, data }: IProps) {
  const {
    ticketCategoryDetailRequestAction,
    adminSupporterRequestAction,
    ticketAddSupporterListAction,
    ticketCategoriesRequestAction,
    ticketCategoryCreateRequestAction,
    ticketCategoryEditRequestAction,
    ticketCategoryIconRequestAction
  } = useActions();

  const navigate = useNavigate();
  const params: any = useParams();

  const fetchData = () => {
    adminSupporterRequestAction({});
    ticketCategoriesRequestAction({ status: true });
    if (params?.id) ticketCategoryDetailRequestAction(params?.id);
  };

  useEffect(() => {
    if (data?.admin?.length) ticketAddSupporterListAction(data?.admin);
  }, [data?.admin?.length]);

  useEffect(() => {
    fetchData();
  }, []);

  const title_en = data?.translation?.find((e: any) => e.language === 'en');
  const title_ar = data?.translation?.find((e: any) => e.language === 'ar');

  const renderTranslations = (titleEn: string, titleAr: string) => {
    return [
      {
        language: 'en',
        translate: titleEn
      },
      {
        language: 'ar',
        translate: titleAr
      }
    ];
  };

  return (
    <S.Content>
      <PanelBoxLayout title="Category" hint="Sub-categories inherit the parent you pick here">
        <Formik
          initialValues={{
            titleEn: title_en?.translation || '',
            titleAr: title_ar?.translation || '',
            dataURL: data?.icon || '',
            file: undefined,
            parentId: data?.parent?.id || undefined,
            // type: data?.type || '',
            imageName: undefined,
            categoryId: params?.id ? parseInt(params?.id) : undefined
          }}
          enableReinitialize
          validationSchema={!params?.id ? ValidationTicketCategory : ''}
          onSubmit={({ ...values }, { setSubmitting }) => {
            setSubmitting(false);
            // if (!supporterList.length) {
            //   toast({
            //     model: 'error',
            //     message: 'You must select at least one supporter'
            //   });
            //   return;
            // }
            if (data?.id) {
              ticketCategoryEditRequestAction(
                {
                  id: data.id,
                  categoryId: values.categoryId,
                  imageName: values.imageName,
                  parentId: values.parentId,
                  // adminIds: supporterList.map((item) => item.id),
                  translations: renderTranslations(values.titleEn, values.titleAr)
                },
                () => navigate('/panel/ticket/categories')
              );
            } else {
              ticketCategoryCreateRequestAction(
                {
                  categoryId: values.categoryId,
                  imageName: values.imageName,
                  parentId: values.parentId,
                  // adminIds: supporterList.map((item) => item.id),
                  translations: renderTranslations(values.titleEn, values.titleAr)
                },
                () => navigate('/panel/ticket/categories')
              );
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            // isSubmitting,
            setValues
          }) => (
            <S.Rows>
              <UploadIcon
                value={{ dataURL: values.dataURL, file: values.file }}
                onChange={(e: T.Form.FileUpload) => {
                  ticketCategoryIconRequestAction({ image: e?.file }, (fileNameOnly: string) => {
                    setValues({
                      ...values,
                      imageName: fileNameOnly as any,
                      dataURL: e.dataURL,
                      file: e.file as any
                    });
                  });
                }}
                label="Icon"
                message={touched.imageName && (errors.imageName as string)}
                error={errors.imageName as unknown as boolean}
              />

              <FieldPair>
                <TextInput
                  label="Category title"
                  langTag="EN"
                  required
                  type="text"
                  name="titleEn"
                  onChange={handleChange}
                  placeholder="Hardware"
                  value={values.titleEn}
                  message={touched.titleEn && (errors.titleEn as string)}
                  error={errors.titleEn as unknown as boolean}
                />

                <TextInput
                  label="Category title"
                  langTag="AR"
                  required
                  dir="rtl"
                  type="text"
                  name="titleAr"
                  onChange={handleChange}
                  placeholder="الأجهزة"
                  value={values.titleAr}
                  message={touched.titleAr && (errors.titleAr as string)}
                  error={errors.titleAr as unknown as boolean}
                />
              </FieldPair>

              <S.Half>
                <TreeSelectInput
                  label="Parent category"
                  list={categories}
                  placeholder={data?.parent?.translation[0]?.translation || 'None — this is a top-level category'}
                  defaultValue={values.parentId?.toString() || ''}
                  key={values.parentId || categories?.length}
                  onChange={(e, item: any) => {
                    setValues({
                      ...values,
                      parentId: Number(e) as any
                    });
                  }}
                />
              </S.Half>

              {/* <DropDown
                label="Category Type"
                name="type"
                list={CategoryTypeEnumArray}
                onChange={(e: T.Form.ListDropdownItem) => {
                  setValues({
                    ...values,
                    type: e.id
                  });
                }}
                placeholder="Please enter category type"
                defaultValue={{ title: values.type, id: values.type }}
                message={touched.type && (errors.type as string)}
                error={errors.type as unknown as boolean}
                disabled={values.parentCategory || data?.id ? true : false}
                // key={values.type}
              />

              <Gap size="20px" /> */}

              {/* <CategoryUserMultiDropdown
                label="Assign Supporter"
                list={supporter}
                placeholder="Select Supporter"
                defaultValues={supporterList}
                onChange={(list) => {
                  ticketAddSupporterListAction(list);
                }}
                // message={
                //   !supporterList.length &&
                //   ("You must select at least one supporter" as any)
                // }
                // error={!supporterList.length as boolean}
              /> */}
              {/* <Gap size="20px" /> */}

              <S.Actions>
                <OutlineButton link="/panel/ticket/categories">Cancel</OutlineButton>
                <PrimaryButton onClick={handleSubmit}>{data?.id ? 'Save category' : 'Create category'}</PrimaryButton>
              </S.Actions>
            </S.Rows>
          )}
        </Formik>
      </PanelBoxLayout>
    </S.Content>
  );
}
